/* tslint:disable */
/* eslint-disable */
/**
 * Trove Partner Suite Configs API
 * This is the Partner Suite Configs API.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: dev@trove.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const AnalyticsHeapDestinationTypeEnum = {
    Heap: 'heap'
};
export const AnalyticsShopifyDestinationTypeEnum = {
    Shopify: 'shopify'
};
export const GetRecyclePluginSettings200ResponseDataTypeEnum = {
    PluginRecycleConfiguration: 'pluginRecycleConfiguration'
};
export const GetRepairPluginSettings200ResponseDataTypeEnum = {
    PluginRepairConfiguration: 'pluginRepairConfiguration'
};
export const GetResalePluginSettings200ResponseDataTypeEnum = {
    PluginResaleConfiguration: 'pluginResaleConfiguration'
};
export const GetTradeinPluginSettings200ResponseDataTypeEnum = {
    PluginTradeinConfiguration: 'pluginTradeinConfiguration'
};
export const GetVersions200ResponseDataInnerTypeEnum = {
    PluginConfigVersion: 'pluginConfigVersion'
};
export const PatchVersionRequestDataTypeEnum = {
    PluginConfigVersion: 'pluginConfigVersion'
};
export const PluginResaleConfigurationProductCardRoundingTypeEnum = {
    None: 'none',
    DollarRound: 'dollar_round'
};
export const PluginResaleConfigurationProductCardColorSwatchesDisplayTypeEnum = {
    Swatch: 'swatch',
    Thumbnail: 'thumbnail'
};
export const PluginResaleProductInfoMSRPDisplayCompareItemPriceEnum = {
    Inline: 'inline',
    None: 'none'
};
export const PluginTradeinConfigurationContactInfoSendbackPreferenceQuestionOrderEnum = {
    ReturnFirst: 'return_first',
    RecycleFirst: 'recycle_first'
};
export const PluginTradeinConfigurationItemEligibilityQuestionsInnerToggleOrderEnum = {
    EligibleFirst: 'eligible_first',
    IneligibleFirst: 'ineligible_first'
};
export const PluginTradeinConfigurationMinimizedPluginAnchorPositionEnum = {
    TopLeft: 'top-left',
    TopRight: 'top-right',
    BottomLeft: 'bottom-left',
    BottomRight: 'bottom-right'
};
export const PluginTradeinConfigurationMinimizedPluginIconPositionEnum = {
    BeforeText: 'before-text',
    AfterText: 'after-text'
};
export const PluginTradeinConfigurationPayoutSelectionPayoutMethodDefaultPayoutOptionEnum = {
    Iban: 'IBAN',
    Giftcard: 'GIFTCARD'
};
/**
 * A type of Trove plugin
 * @export
 * @enum {string}
 */
export const PluginType = {
    Recycle: 'recycle',
    Repair: 'repair',
    Resale: 'resale',
    Tradein: 'tradein'
};
export const PostVersionRequestDataTypeEnum = {
    PluginConfigVersionPost: 'pluginConfigVersionPost'
};
export const PutResalePluginBadgeRequestDataTypeEnum = {
    PluginResaleBadgeConfiguration: 'pluginResaleBadgeConfiguration'
};
export const PutResalePluginButtonRequestDataTypeEnum = {
    PluginResaleButtonConfiguration: 'pluginResaleButtonConfiguration'
};
export const PutResalePluginHeaderRequestDataTypeEnum = {
    PluginResaleHeaderConfiguration: 'pluginResaleHeaderConfiguration'
};
export const PutResalePluginMarketingTileRequestDataTypeEnum = {
    PluginResaleMarketingTileConfiguration: 'pluginResaleMarketingTileConfiguration'
};
export const PutResalePluginProductInfoRequestDataTypeEnum = {
    PluginResaleProductInfoConfiguration: 'pluginResaleProductInfoConfiguration'
};
export const PutTradeinPluginDialogHeaderRequestDataTypeEnum = {
    PluginTradeinDialogHeaderConfiguration: 'pluginTradeinDialogHeaderConfiguration'
};
export const PutTradeinPluginDialogRequestDataTypeEnum = {
    PluginTradeinDialogConfiguration: 'pluginTradeinDialogConfiguration'
};
export const PutTradeinPluginGeneralRequestDataTypeEnum = {
    PluginTradeinGeneralConfiguration: 'pluginTradeinGeneralConfiguration'
};
export const PutTradeinPluginSearchRequestDataTypeEnum = {
    PluginTradeinSearchConfiguration: 'pluginTradeinSearchConfiguration'
};
export const SetDefaultVersionRequestDataTypeEnum = {
    PluginDefaultConfigVersionPut: 'pluginDefaultConfigVersionPut'
};
/**
 * ConfigsApi - axios parameter creator
 * @export
 */
export const ConfigsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Deletes a plugin config version
         * @summary Deletes a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVersion: (type_1, partnerCode_1, version_1, ...args_1) => __awaiter(this, [type_1, partnerCode_1, version_1, ...args_1], void 0, function* (type, partnerCode, version, options = {}) {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('deleteVersion', 'type', type);
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('deleteVersion', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('deleteVersion', 'version', version);
            const localVarPath = `/plugin/{type}/{partnerCode}/versions/{version}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets all recycle plugin settings for the given version.
         * @summary Gets recycle plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecyclePluginSettings: (partnerCode_1, version_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, ...args_1], void 0, function* (partnerCode, version, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('getRecyclePluginSettings', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getRecyclePluginSettings', 'version', version);
            const localVarPath = `/plugin/recycle/{partnerCode}/versions/{version}/settings`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets all repair plugin settings for the given version.
         * @summary Gets repair plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairPluginSettings: (partnerCode_1, version_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, ...args_1], void 0, function* (partnerCode, version, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('getRepairPluginSettings', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getRepairPluginSettings', 'version', version);
            const localVarPath = `/plugin/repair/{partnerCode}/versions/{version}/settings`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets all resale plugin settings for the given version.
         * @summary Gets resale plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResalePluginSettings: (partnerCode_1, version_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, ...args_1], void 0, function* (partnerCode, version, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('getResalePluginSettings', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getResalePluginSettings', 'version', version);
            const localVarPath = `/plugin/resale/{partnerCode}/versions/{version}/settings`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets all tradein plugin settings for the given version.
         * @summary Gets tradein plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeinPluginSettings: (partnerCode_1, version_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, ...args_1], void 0, function* (partnerCode, version, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('getTradeinPluginSettings', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getTradeinPluginSettings', 'version', version);
            const localVarPath = `/plugin/tradein/{partnerCode}/versions/{version}/settings`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves a plugin configuration version by ID
         * @summary Get a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersion: (type_1, partnerCode_1, version_1, ...args_1) => __awaiter(this, [type_1, partnerCode_1, version_1, ...args_1], void 0, function* (type, partnerCode, version, options = {}) {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getVersion', 'type', type);
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('getVersion', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getVersion', 'version', version);
            const localVarPath = `/plugin/{type}/{partnerCode}/versions/{version}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the plugin config version collection
         * @summary Gets the plugin config version collection
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersions: (type_1, partnerCode_1, ...args_1) => __awaiter(this, [type_1, partnerCode_1, ...args_1], void 0, function* (type, partnerCode, options = {}) {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getVersions', 'type', type);
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('getVersions', 'partnerCode', partnerCode);
            const localVarPath = `/plugin/{type}/{partnerCode}/versions`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a plugin config version
         * @summary Updates a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PatchVersionRequest} [patchVersionRequest] An object with config version updates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchVersion: (type_1, partnerCode_1, version_1, patchVersionRequest_1, ...args_1) => __awaiter(this, [type_1, partnerCode_1, version_1, patchVersionRequest_1, ...args_1], void 0, function* (type, partnerCode, version, patchVersionRequest, options = {}) {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('patchVersion', 'type', type);
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('patchVersion', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('patchVersion', 'version', version);
            const localVarPath = `/plugin/{type}/{partnerCode}/versions/{version}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(patchVersionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a plugin config version
         * @summary Creates a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {PostVersionRequest} [postVersionRequest] Information about the new config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVersion: (type_1, partnerCode_1, postVersionRequest_1, ...args_1) => __awaiter(this, [type_1, partnerCode_1, postVersionRequest_1, ...args_1], void 0, function* (type, partnerCode, postVersionRequest, options = {}) {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('postVersion', 'type', type);
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('postVersion', 'partnerCode', partnerCode);
            const localVarPath = `/plugin/{type}/{partnerCode}/versions`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(postVersionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces all recycle plugin settings for the given version.
         * @summary Replaces recycle plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetRecyclePluginSettings200Response} getRecyclePluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRecyclePluginSettings: (partnerCode_1, version_1, getRecyclePluginSettings200Response_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, getRecyclePluginSettings200Response_1, ...args_1], void 0, function* (partnerCode, version, getRecyclePluginSettings200Response, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putRecyclePluginSettings', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putRecyclePluginSettings', 'version', version);
            // verify required parameter 'getRecyclePluginSettings200Response' is not null or undefined
            assertParamExists('putRecyclePluginSettings', 'getRecyclePluginSettings200Response', getRecyclePluginSettings200Response);
            const localVarPath = `/plugin/recycle/{partnerCode}/versions/{version}/settings`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getRecyclePluginSettings200Response, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces all repair plugin settings for the given version.
         * @summary Replaces repair plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetRepairPluginSettings200Response} getRepairPluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRepairPluginSettings: (partnerCode_1, version_1, getRepairPluginSettings200Response_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, getRepairPluginSettings200Response_1, ...args_1], void 0, function* (partnerCode, version, getRepairPluginSettings200Response, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putRepairPluginSettings', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putRepairPluginSettings', 'version', version);
            // verify required parameter 'getRepairPluginSettings200Response' is not null or undefined
            assertParamExists('putRepairPluginSettings', 'getRepairPluginSettings200Response', getRepairPluginSettings200Response);
            const localVarPath = `/plugin/repair/{partnerCode}/versions/{version}/settings`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getRepairPluginSettings200Response, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces the badge configuration for a Resale Plugin config version
         * @summary Replaces the badge configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginBadgeRequest} [putResalePluginBadgeRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginBadge: (partnerCode_1, version_1, putResalePluginBadgeRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, putResalePluginBadgeRequest_1, ...args_1], void 0, function* (partnerCode, version, putResalePluginBadgeRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putResalePluginBadge', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putResalePluginBadge', 'version', version);
            const localVarPath = `/plugin/resale/{partnerCode}/versions/{version}/badge`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putResalePluginBadgeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces the button configuration for a Resale Plugin config version
         * @summary Replaces the button configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginButtonRequest} [putResalePluginButtonRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginButton: (partnerCode_1, version_1, putResalePluginButtonRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, putResalePluginButtonRequest_1, ...args_1], void 0, function* (partnerCode, version, putResalePluginButtonRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putResalePluginButton', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putResalePluginButton', 'version', version);
            const localVarPath = `/plugin/resale/{partnerCode}/versions/{version}/button`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putResalePluginButtonRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces the header configuration for a Resale Plugin config version
         * @summary Replaces the header configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginHeaderRequest} [putResalePluginHeaderRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginHeader: (partnerCode_1, version_1, putResalePluginHeaderRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, putResalePluginHeaderRequest_1, ...args_1], void 0, function* (partnerCode, version, putResalePluginHeaderRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putResalePluginHeader', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putResalePluginHeader', 'version', version);
            const localVarPath = `/plugin/resale/{partnerCode}/versions/{version}/header`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putResalePluginHeaderRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces the marketing tile configuration for a Resale Plugin config version
         * @summary Replaces the marketing tile configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginMarketingTileRequest} [putResalePluginMarketingTileRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginMarketingTile: (partnerCode_1, version_1, putResalePluginMarketingTileRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, putResalePluginMarketingTileRequest_1, ...args_1], void 0, function* (partnerCode, version, putResalePluginMarketingTileRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putResalePluginMarketingTile', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putResalePluginMarketingTile', 'version', version);
            const localVarPath = `/plugin/resale/{partnerCode}/versions/{version}/marketingTile`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putResalePluginMarketingTileRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces the product info configuration for a Resale Plugin config version
         * @summary Replaces the product info configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginProductInfoRequest} [putResalePluginProductInfoRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginProductInfo: (partnerCode_1, version_1, putResalePluginProductInfoRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, putResalePluginProductInfoRequest_1, ...args_1], void 0, function* (partnerCode, version, putResalePluginProductInfoRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putResalePluginProductInfo', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putResalePluginProductInfo', 'version', version);
            const localVarPath = `/plugin/resale/{partnerCode}/versions/{version}/productInfo`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putResalePluginProductInfoRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces all resale plugin settings for the given version.
         * @summary Replaces resale plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetResalePluginSettings200Response} getResalePluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putResalePluginSettings: (partnerCode_1, version_1, getResalePluginSettings200Response_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, getResalePluginSettings200Response_1, ...args_1], void 0, function* (partnerCode, version, getResalePluginSettings200Response, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putResalePluginSettings', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putResalePluginSettings', 'version', version);
            // verify required parameter 'getResalePluginSettings200Response' is not null or undefined
            assertParamExists('putResalePluginSettings', 'getResalePluginSettings200Response', getResalePluginSettings200Response);
            const localVarPath = `/plugin/resale/{partnerCode}/versions/{version}/settings`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getResalePluginSettings200Response, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces the dialog configuration for a Trade-in Plugin config version
         * @summary Replaces the dialog configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginDialogRequest} [putTradeinPluginDialogRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginDialog: (partnerCode_1, version_1, putTradeinPluginDialogRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, putTradeinPluginDialogRequest_1, ...args_1], void 0, function* (partnerCode, version, putTradeinPluginDialogRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putTradeinPluginDialog', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putTradeinPluginDialog', 'version', version);
            const localVarPath = `/plugin/tradein/{partnerCode}/versions/{version}/dialog`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putTradeinPluginDialogRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces the dialog header configuration for a Trade-in Plugin config version
         * @summary Replaces the dialog header configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginDialogHeaderRequest} [putTradeinPluginDialogHeaderRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginDialogHeader: (partnerCode_1, version_1, putTradeinPluginDialogHeaderRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, putTradeinPluginDialogHeaderRequest_1, ...args_1], void 0, function* (partnerCode, version, putTradeinPluginDialogHeaderRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putTradeinPluginDialogHeader', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putTradeinPluginDialogHeader', 'version', version);
            const localVarPath = `/plugin/tradein/{partnerCode}/versions/{version}/dialogHeader`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putTradeinPluginDialogHeaderRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces general configuration for a Trade-in Plugin config version
         * @summary Replaces general configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginGeneralRequest} [putTradeinPluginGeneralRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginGeneral: (partnerCode_1, version_1, putTradeinPluginGeneralRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, putTradeinPluginGeneralRequest_1, ...args_1], void 0, function* (partnerCode, version, putTradeinPluginGeneralRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putTradeinPluginGeneral', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putTradeinPluginGeneral', 'version', version);
            const localVarPath = `/plugin/tradein/{partnerCode}/versions/{version}/general`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putTradeinPluginGeneralRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces search configuration for a Trade-in Plugin config version
         * @summary Replaces search configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginSearchRequest} [putTradeinPluginSearchRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginSearch: (partnerCode_1, version_1, putTradeinPluginSearchRequest_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, putTradeinPluginSearchRequest_1, ...args_1], void 0, function* (partnerCode, version, putTradeinPluginSearchRequest, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putTradeinPluginSearch', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putTradeinPluginSearch', 'version', version);
            const localVarPath = `/plugin/tradein/{partnerCode}/versions/{version}/search`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(putTradeinPluginSearchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Replaces all tradein plugin settings for the given version.
         * @summary Replaces tradein plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetTradeinPluginSettings200Response} getTradeinPluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTradeinPluginSettings: (partnerCode_1, version_1, getTradeinPluginSettings200Response_1, ...args_1) => __awaiter(this, [partnerCode_1, version_1, getTradeinPluginSettings200Response_1, ...args_1], void 0, function* (partnerCode, version, getTradeinPluginSettings200Response, options = {}) {
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('putTradeinPluginSettings', 'partnerCode', partnerCode);
            // verify required parameter 'version' is not null or undefined
            assertParamExists('putTradeinPluginSettings', 'version', version);
            // verify required parameter 'getTradeinPluginSettings200Response' is not null or undefined
            assertParamExists('putTradeinPluginSettings', 'getTradeinPluginSettings200Response', getTradeinPluginSettings200Response);
            const localVarPath = `/plugin/tradein/{partnerCode}/versions/{version}/settings`
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getTradeinPluginSettings200Response, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Sets the default config version
         * @summary Sets the default config version
         * @param {string} type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {SetDefaultVersionRequest} [setDefaultVersionRequest] Default version info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultVersion: (type_1, partnerCode_1, setDefaultVersionRequest_1, ...args_1) => __awaiter(this, [type_1, partnerCode_1, setDefaultVersionRequest_1, ...args_1], void 0, function* (type, partnerCode, setDefaultVersionRequest, options = {}) {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('setDefaultVersion', 'type', type);
            // verify required parameter 'partnerCode' is not null or undefined
            assertParamExists('setDefaultVersion', 'partnerCode', partnerCode);
            const localVarPath = `/plugin/{type}/{partnerCode}/versions/default`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"partnerCode"}}`, encodeURIComponent(String(partnerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication TroveUserToken required
            yield setApiKeyToObject(localVarHeaderParameter, "X-TROVE-USER-TOKEN", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setDefaultVersionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigsApi - functional programming interface
 * @export
 */
export const ConfigsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigsApiAxiosParamCreator(configuration);
    return {
        /**
         * Deletes a plugin config version
         * @summary Deletes a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVersion(type, partnerCode, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteVersion(type, partnerCode, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.deleteVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets all recycle plugin settings for the given version.
         * @summary Gets recycle plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecyclePluginSettings(partnerCode, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecyclePluginSettings(partnerCode, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.getRecyclePluginSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets all repair plugin settings for the given version.
         * @summary Gets repair plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairPluginSettings(partnerCode, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRepairPluginSettings(partnerCode, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.getRepairPluginSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets all resale plugin settings for the given version.
         * @summary Gets resale plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResalePluginSettings(partnerCode, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResalePluginSettings(partnerCode, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.getResalePluginSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets all tradein plugin settings for the given version.
         * @summary Gets tradein plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeinPluginSettings(partnerCode, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTradeinPluginSettings(partnerCode, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.getTradeinPluginSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves a plugin configuration version by ID
         * @summary Get a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersion(type, partnerCode, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVersion(type, partnerCode, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.getVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets the plugin config version collection
         * @summary Gets the plugin config version collection
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersions(type, partnerCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVersions(type, partnerCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.getVersions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Updates a plugin config version
         * @summary Updates a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PatchVersionRequest} [patchVersionRequest] An object with config version updates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchVersion(type, partnerCode, version, patchVersionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchVersion(type, partnerCode, version, patchVersionRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.patchVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creates a plugin config version
         * @summary Creates a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {PostVersionRequest} [postVersionRequest] Information about the new config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVersion(type, partnerCode, postVersionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postVersion(type, partnerCode, postVersionRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.postVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces all recycle plugin settings for the given version.
         * @summary Replaces recycle plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetRecyclePluginSettings200Response} getRecyclePluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRecyclePluginSettings(partnerCode, version, getRecyclePluginSettings200Response, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putRecyclePluginSettings(partnerCode, version, getRecyclePluginSettings200Response, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putRecyclePluginSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces all repair plugin settings for the given version.
         * @summary Replaces repair plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetRepairPluginSettings200Response} getRepairPluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRepairPluginSettings(partnerCode, version, getRepairPluginSettings200Response, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putRepairPluginSettings(partnerCode, version, getRepairPluginSettings200Response, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putRepairPluginSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces the badge configuration for a Resale Plugin config version
         * @summary Replaces the badge configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginBadgeRequest} [putResalePluginBadgeRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginBadge(partnerCode, version, putResalePluginBadgeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putResalePluginBadge(partnerCode, version, putResalePluginBadgeRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putResalePluginBadge']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces the button configuration for a Resale Plugin config version
         * @summary Replaces the button configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginButtonRequest} [putResalePluginButtonRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginButton(partnerCode, version, putResalePluginButtonRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putResalePluginButton(partnerCode, version, putResalePluginButtonRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putResalePluginButton']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces the header configuration for a Resale Plugin config version
         * @summary Replaces the header configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginHeaderRequest} [putResalePluginHeaderRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginHeader(partnerCode, version, putResalePluginHeaderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putResalePluginHeader(partnerCode, version, putResalePluginHeaderRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putResalePluginHeader']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces the marketing tile configuration for a Resale Plugin config version
         * @summary Replaces the marketing tile configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginMarketingTileRequest} [putResalePluginMarketingTileRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginMarketingTile(partnerCode, version, putResalePluginMarketingTileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putResalePluginMarketingTile(partnerCode, version, putResalePluginMarketingTileRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putResalePluginMarketingTile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces the product info configuration for a Resale Plugin config version
         * @summary Replaces the product info configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginProductInfoRequest} [putResalePluginProductInfoRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginProductInfo(partnerCode, version, putResalePluginProductInfoRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putResalePluginProductInfo(partnerCode, version, putResalePluginProductInfoRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putResalePluginProductInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces all resale plugin settings for the given version.
         * @summary Replaces resale plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetResalePluginSettings200Response} getResalePluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putResalePluginSettings(partnerCode, version, getResalePluginSettings200Response, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putResalePluginSettings(partnerCode, version, getResalePluginSettings200Response, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putResalePluginSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces the dialog configuration for a Trade-in Plugin config version
         * @summary Replaces the dialog configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginDialogRequest} [putTradeinPluginDialogRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginDialog(partnerCode, version, putTradeinPluginDialogRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putTradeinPluginDialog(partnerCode, version, putTradeinPluginDialogRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putTradeinPluginDialog']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces the dialog header configuration for a Trade-in Plugin config version
         * @summary Replaces the dialog header configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginDialogHeaderRequest} [putTradeinPluginDialogHeaderRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginDialogHeader(partnerCode, version, putTradeinPluginDialogHeaderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putTradeinPluginDialogHeader(partnerCode, version, putTradeinPluginDialogHeaderRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putTradeinPluginDialogHeader']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces general configuration for a Trade-in Plugin config version
         * @summary Replaces general configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginGeneralRequest} [putTradeinPluginGeneralRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginGeneral(partnerCode, version, putTradeinPluginGeneralRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putTradeinPluginGeneral(partnerCode, version, putTradeinPluginGeneralRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putTradeinPluginGeneral']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces search configuration for a Trade-in Plugin config version
         * @summary Replaces search configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginSearchRequest} [putTradeinPluginSearchRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginSearch(partnerCode, version, putTradeinPluginSearchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putTradeinPluginSearch(partnerCode, version, putTradeinPluginSearchRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putTradeinPluginSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Replaces all tradein plugin settings for the given version.
         * @summary Replaces tradein plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetTradeinPluginSettings200Response} getTradeinPluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTradeinPluginSettings(partnerCode, version, getTradeinPluginSettings200Response, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putTradeinPluginSettings(partnerCode, version, getTradeinPluginSettings200Response, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.putTradeinPluginSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Sets the default config version
         * @summary Sets the default config version
         * @param {string} type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {SetDefaultVersionRequest} [setDefaultVersionRequest] Default version info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultVersion(type, partnerCode, setDefaultVersionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setDefaultVersion(type, partnerCode, setDefaultVersionRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigsApi.setDefaultVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ConfigsApi - factory interface
 * @export
 */
export const ConfigsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigsApiFp(configuration);
    return {
        /**
         * Deletes a plugin config version
         * @summary Deletes a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVersion(type, partnerCode, version, options) {
            return localVarFp.deleteVersion(type, partnerCode, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all recycle plugin settings for the given version.
         * @summary Gets recycle plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecyclePluginSettings(partnerCode, version, options) {
            return localVarFp.getRecyclePluginSettings(partnerCode, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all repair plugin settings for the given version.
         * @summary Gets repair plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairPluginSettings(partnerCode, version, options) {
            return localVarFp.getRepairPluginSettings(partnerCode, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all resale plugin settings for the given version.
         * @summary Gets resale plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResalePluginSettings(partnerCode, version, options) {
            return localVarFp.getResalePluginSettings(partnerCode, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all tradein plugin settings for the given version.
         * @summary Gets tradein plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTradeinPluginSettings(partnerCode, version, options) {
            return localVarFp.getTradeinPluginSettings(partnerCode, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a plugin configuration version by ID
         * @summary Get a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersion(type, partnerCode, version, options) {
            return localVarFp.getVersion(type, partnerCode, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the plugin config version collection
         * @summary Gets the plugin config version collection
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersions(type, partnerCode, options) {
            return localVarFp.getVersions(type, partnerCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a plugin config version
         * @summary Updates a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PatchVersionRequest} [patchVersionRequest] An object with config version updates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchVersion(type, partnerCode, version, patchVersionRequest, options) {
            return localVarFp.patchVersion(type, partnerCode, version, patchVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a plugin config version
         * @summary Creates a plugin config version
         * @param {PluginType} type The plugin type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {PostVersionRequest} [postVersionRequest] Information about the new config version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVersion(type, partnerCode, postVersionRequest, options) {
            return localVarFp.postVersion(type, partnerCode, postVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces all recycle plugin settings for the given version.
         * @summary Replaces recycle plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetRecyclePluginSettings200Response} getRecyclePluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRecyclePluginSettings(partnerCode, version, getRecyclePluginSettings200Response, options) {
            return localVarFp.putRecyclePluginSettings(partnerCode, version, getRecyclePluginSettings200Response, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces all repair plugin settings for the given version.
         * @summary Replaces repair plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetRepairPluginSettings200Response} getRepairPluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRepairPluginSettings(partnerCode, version, getRepairPluginSettings200Response, options) {
            return localVarFp.putRepairPluginSettings(partnerCode, version, getRepairPluginSettings200Response, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the badge configuration for a Resale Plugin config version
         * @summary Replaces the badge configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginBadgeRequest} [putResalePluginBadgeRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginBadge(partnerCode, version, putResalePluginBadgeRequest, options) {
            return localVarFp.putResalePluginBadge(partnerCode, version, putResalePluginBadgeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the button configuration for a Resale Plugin config version
         * @summary Replaces the button configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginButtonRequest} [putResalePluginButtonRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginButton(partnerCode, version, putResalePluginButtonRequest, options) {
            return localVarFp.putResalePluginButton(partnerCode, version, putResalePluginButtonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the header configuration for a Resale Plugin config version
         * @summary Replaces the header configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginHeaderRequest} [putResalePluginHeaderRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginHeader(partnerCode, version, putResalePluginHeaderRequest, options) {
            return localVarFp.putResalePluginHeader(partnerCode, version, putResalePluginHeaderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the marketing tile configuration for a Resale Plugin config version
         * @summary Replaces the marketing tile configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginMarketingTileRequest} [putResalePluginMarketingTileRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginMarketingTile(partnerCode, version, putResalePluginMarketingTileRequest, options) {
            return localVarFp.putResalePluginMarketingTile(partnerCode, version, putResalePluginMarketingTileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the product info configuration for a Resale Plugin config version
         * @summary Replaces the product info configuration for a Resale Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutResalePluginProductInfoRequest} [putResalePluginProductInfoRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putResalePluginProductInfo(partnerCode, version, putResalePluginProductInfoRequest, options) {
            return localVarFp.putResalePluginProductInfo(partnerCode, version, putResalePluginProductInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces all resale plugin settings for the given version.
         * @summary Replaces resale plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetResalePluginSettings200Response} getResalePluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putResalePluginSettings(partnerCode, version, getResalePluginSettings200Response, options) {
            return localVarFp.putResalePluginSettings(partnerCode, version, getResalePluginSettings200Response, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the dialog configuration for a Trade-in Plugin config version
         * @summary Replaces the dialog configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginDialogRequest} [putTradeinPluginDialogRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginDialog(partnerCode, version, putTradeinPluginDialogRequest, options) {
            return localVarFp.putTradeinPluginDialog(partnerCode, version, putTradeinPluginDialogRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the dialog header configuration for a Trade-in Plugin config version
         * @summary Replaces the dialog header configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginDialogHeaderRequest} [putTradeinPluginDialogHeaderRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginDialogHeader(partnerCode, version, putTradeinPluginDialogHeaderRequest, options) {
            return localVarFp.putTradeinPluginDialogHeader(partnerCode, version, putTradeinPluginDialogHeaderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces general configuration for a Trade-in Plugin config version
         * @summary Replaces general configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginGeneralRequest} [putTradeinPluginGeneralRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginGeneral(partnerCode, version, putTradeinPluginGeneralRequest, options) {
            return localVarFp.putTradeinPluginGeneral(partnerCode, version, putTradeinPluginGeneralRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces search configuration for a Trade-in Plugin config version
         * @summary Replaces search configuration for a Trade-in Plugin config version
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {PutTradeinPluginSearchRequest} [putTradeinPluginSearchRequest] Plugin configuration replacement
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        putTradeinPluginSearch(partnerCode, version, putTradeinPluginSearchRequest, options) {
            return localVarFp.putTradeinPluginSearch(partnerCode, version, putTradeinPluginSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces all tradein plugin settings for the given version.
         * @summary Replaces tradein plugin settings
         * @param {string} partnerCode Unique identifier of the partner
         * @param {string} version Unique identifier of the config version
         * @param {GetTradeinPluginSettings200Response} getTradeinPluginSettings200Response An object containing plugin settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTradeinPluginSettings(partnerCode, version, getTradeinPluginSettings200Response, options) {
            return localVarFp.putTradeinPluginSettings(partnerCode, version, getTradeinPluginSettings200Response, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the default config version
         * @summary Sets the default config version
         * @param {string} type
         * @param {string} partnerCode Unique identifier of the partner
         * @param {SetDefaultVersionRequest} [setDefaultVersionRequest] Default version info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultVersion(type, partnerCode, setDefaultVersionRequest, options) {
            return localVarFp.setDefaultVersion(type, partnerCode, setDefaultVersionRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigsApi - object-oriented interface
 * @export
 * @class ConfigsApi
 * @extends {BaseAPI}
 */
export class ConfigsApi extends BaseAPI {
    /**
     * Deletes a plugin config version
     * @summary Deletes a plugin config version
     * @param {PluginType} type The plugin type
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    deleteVersion(type, partnerCode, version, options) {
        return ConfigsApiFp(this.configuration).deleteVersion(type, partnerCode, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all recycle plugin settings for the given version.
     * @summary Gets recycle plugin settings
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    getRecyclePluginSettings(partnerCode, version, options) {
        return ConfigsApiFp(this.configuration).getRecyclePluginSettings(partnerCode, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all repair plugin settings for the given version.
     * @summary Gets repair plugin settings
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    getRepairPluginSettings(partnerCode, version, options) {
        return ConfigsApiFp(this.configuration).getRepairPluginSettings(partnerCode, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all resale plugin settings for the given version.
     * @summary Gets resale plugin settings
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    getResalePluginSettings(partnerCode, version, options) {
        return ConfigsApiFp(this.configuration).getResalePluginSettings(partnerCode, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all tradein plugin settings for the given version.
     * @summary Gets tradein plugin settings
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    getTradeinPluginSettings(partnerCode, version, options) {
        return ConfigsApiFp(this.configuration).getTradeinPluginSettings(partnerCode, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a plugin configuration version by ID
     * @summary Get a plugin config version
     * @param {PluginType} type The plugin type
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    getVersion(type, partnerCode, version, options) {
        return ConfigsApiFp(this.configuration).getVersion(type, partnerCode, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the plugin config version collection
     * @summary Gets the plugin config version collection
     * @param {PluginType} type The plugin type
     * @param {string} partnerCode Unique identifier of the partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    getVersions(type, partnerCode, options) {
        return ConfigsApiFp(this.configuration).getVersions(type, partnerCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a plugin config version
     * @summary Updates a plugin config version
     * @param {PluginType} type The plugin type
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PatchVersionRequest} [patchVersionRequest] An object with config version updates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    patchVersion(type, partnerCode, version, patchVersionRequest, options) {
        return ConfigsApiFp(this.configuration).patchVersion(type, partnerCode, version, patchVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a plugin config version
     * @summary Creates a plugin config version
     * @param {PluginType} type The plugin type
     * @param {string} partnerCode Unique identifier of the partner
     * @param {PostVersionRequest} [postVersionRequest] Information about the new config version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    postVersion(type, partnerCode, postVersionRequest, options) {
        return ConfigsApiFp(this.configuration).postVersion(type, partnerCode, postVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces all recycle plugin settings for the given version.
     * @summary Replaces recycle plugin settings
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {GetRecyclePluginSettings200Response} getRecyclePluginSettings200Response An object containing plugin settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putRecyclePluginSettings(partnerCode, version, getRecyclePluginSettings200Response, options) {
        return ConfigsApiFp(this.configuration).putRecyclePluginSettings(partnerCode, version, getRecyclePluginSettings200Response, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces all repair plugin settings for the given version.
     * @summary Replaces repair plugin settings
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {GetRepairPluginSettings200Response} getRepairPluginSettings200Response An object containing plugin settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putRepairPluginSettings(partnerCode, version, getRepairPluginSettings200Response, options) {
        return ConfigsApiFp(this.configuration).putRepairPluginSettings(partnerCode, version, getRepairPluginSettings200Response, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces the badge configuration for a Resale Plugin config version
     * @summary Replaces the badge configuration for a Resale Plugin config version
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PutResalePluginBadgeRequest} [putResalePluginBadgeRequest] Plugin configuration replacement
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putResalePluginBadge(partnerCode, version, putResalePluginBadgeRequest, options) {
        return ConfigsApiFp(this.configuration).putResalePluginBadge(partnerCode, version, putResalePluginBadgeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces the button configuration for a Resale Plugin config version
     * @summary Replaces the button configuration for a Resale Plugin config version
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PutResalePluginButtonRequest} [putResalePluginButtonRequest] Plugin configuration replacement
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putResalePluginButton(partnerCode, version, putResalePluginButtonRequest, options) {
        return ConfigsApiFp(this.configuration).putResalePluginButton(partnerCode, version, putResalePluginButtonRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces the header configuration for a Resale Plugin config version
     * @summary Replaces the header configuration for a Resale Plugin config version
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PutResalePluginHeaderRequest} [putResalePluginHeaderRequest] Plugin configuration replacement
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putResalePluginHeader(partnerCode, version, putResalePluginHeaderRequest, options) {
        return ConfigsApiFp(this.configuration).putResalePluginHeader(partnerCode, version, putResalePluginHeaderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces the marketing tile configuration for a Resale Plugin config version
     * @summary Replaces the marketing tile configuration for a Resale Plugin config version
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PutResalePluginMarketingTileRequest} [putResalePluginMarketingTileRequest] Plugin configuration replacement
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putResalePluginMarketingTile(partnerCode, version, putResalePluginMarketingTileRequest, options) {
        return ConfigsApiFp(this.configuration).putResalePluginMarketingTile(partnerCode, version, putResalePluginMarketingTileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces the product info configuration for a Resale Plugin config version
     * @summary Replaces the product info configuration for a Resale Plugin config version
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PutResalePluginProductInfoRequest} [putResalePluginProductInfoRequest] Plugin configuration replacement
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putResalePluginProductInfo(partnerCode, version, putResalePluginProductInfoRequest, options) {
        return ConfigsApiFp(this.configuration).putResalePluginProductInfo(partnerCode, version, putResalePluginProductInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces all resale plugin settings for the given version.
     * @summary Replaces resale plugin settings
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {GetResalePluginSettings200Response} getResalePluginSettings200Response An object containing plugin settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putResalePluginSettings(partnerCode, version, getResalePluginSettings200Response, options) {
        return ConfigsApiFp(this.configuration).putResalePluginSettings(partnerCode, version, getResalePluginSettings200Response, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces the dialog configuration for a Trade-in Plugin config version
     * @summary Replaces the dialog configuration for a Trade-in Plugin config version
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PutTradeinPluginDialogRequest} [putTradeinPluginDialogRequest] Plugin configuration replacement
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putTradeinPluginDialog(partnerCode, version, putTradeinPluginDialogRequest, options) {
        return ConfigsApiFp(this.configuration).putTradeinPluginDialog(partnerCode, version, putTradeinPluginDialogRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces the dialog header configuration for a Trade-in Plugin config version
     * @summary Replaces the dialog header configuration for a Trade-in Plugin config version
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PutTradeinPluginDialogHeaderRequest} [putTradeinPluginDialogHeaderRequest] Plugin configuration replacement
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putTradeinPluginDialogHeader(partnerCode, version, putTradeinPluginDialogHeaderRequest, options) {
        return ConfigsApiFp(this.configuration).putTradeinPluginDialogHeader(partnerCode, version, putTradeinPluginDialogHeaderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces general configuration for a Trade-in Plugin config version
     * @summary Replaces general configuration for a Trade-in Plugin config version
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PutTradeinPluginGeneralRequest} [putTradeinPluginGeneralRequest] Plugin configuration replacement
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putTradeinPluginGeneral(partnerCode, version, putTradeinPluginGeneralRequest, options) {
        return ConfigsApiFp(this.configuration).putTradeinPluginGeneral(partnerCode, version, putTradeinPluginGeneralRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces search configuration for a Trade-in Plugin config version
     * @summary Replaces search configuration for a Trade-in Plugin config version
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {PutTradeinPluginSearchRequest} [putTradeinPluginSearchRequest] Plugin configuration replacement
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putTradeinPluginSearch(partnerCode, version, putTradeinPluginSearchRequest, options) {
        return ConfigsApiFp(this.configuration).putTradeinPluginSearch(partnerCode, version, putTradeinPluginSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replaces all tradein plugin settings for the given version.
     * @summary Replaces tradein plugin settings
     * @param {string} partnerCode Unique identifier of the partner
     * @param {string} version Unique identifier of the config version
     * @param {GetTradeinPluginSettings200Response} getTradeinPluginSettings200Response An object containing plugin settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    putTradeinPluginSettings(partnerCode, version, getTradeinPluginSettings200Response, options) {
        return ConfigsApiFp(this.configuration).putTradeinPluginSettings(partnerCode, version, getTradeinPluginSettings200Response, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sets the default config version
     * @summary Sets the default config version
     * @param {string} type
     * @param {string} partnerCode Unique identifier of the partner
     * @param {SetDefaultVersionRequest} [setDefaultVersionRequest] Default version info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigsApi
     */
    setDefaultVersion(type, partnerCode, setDefaultVersionRequest, options) {
        return ConfigsApiFp(this.configuration).setDefaultVersion(type, partnerCode, setDefaultVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map